<template>
    <TopNav></TopNav>
    <h1>Validator IBAN</h1>
    <fieldset>
        <legend>Validator IBAN</legend>
        <label for="ibanInput">IBAN:</label> <input type="text" v-model="inputIban" id="ibanInput" size="40">
        <br><br>
        Validare: <span v-bind:class="classObject()">{{ validationStatus() }}</span>
    </fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'
import IBAN from 'iban'

export default {
  name: "IbanValidator",
  data() {
    return {
      inputIban: ""
    }
  },
  components: {
    TopNav
  },
  methods: {
    validationStatus: function () {
      if (IBAN.isValid(this.inputIban)) {
        return "Valabil";
      } else if (IBAN.isValid(this.inputIban) == false && this.inputIban.length > 0) {
        return "Nu este valabil";
      } else {
        return "";
      }
    },
    classObject: function () {
      if (IBAN.isValid(this.inputIban)) {
        return {
          "positive": true
        }
      } else {
        return {
          "negative": true
        }
      }
    }
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

body {
  margin: 1em auto;
  margin-top: 0;
  max-width: 40em;
  font-family: Arial, Helvetica, sans-serif;
}

label {
  display: inline-block;
  width: 50px;
}

footer section a {
  margin: 20px;
}

label {
  display: inline-block;
  width: 110px;
}

.positive {
  color: #008A00
}

.negative {
  color: #EB0000
}
</style>
